export const SITE = {
  name: "Rama Electricals",
  domain: "https://rama-electricals.com",
  phone: "+91 93221 26690",
  phoneRaw: "+919322126690",
  whatsapp: "919322126690",
  email: "hello@rama-electricals.com",
  gstin: "27JCKPD9500D1ZO",
  addressLines: ["A321, MasterMind IV, Royal Palms", "Goregaon East, Mumbai 400065", "Maharashtra, India"],
  addressFull: "A321, MasterMind IV, Royal Palms, Goregaon East, Mumbai, Maharashtra 400065",
  mapSrc:
    "https://www.google.com/maps?q=MasterMind+IV,+Royal+Palms,+Goregaon+East,+Mumbai+400065&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=MasterMind+IV+Royal+Palms+Goregaon+East+Mumbai+400065",
};

export const waLink = (text) => `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const CATEGORIES = [
  {
    id: "wires",
    title: "Wires & Cables",
    tag: "FR · FRLS · ZHFR",
    text: "House wiring, flexible copper cables, armoured power cables, coaxial and LAN cables from India's most trusted cable makers, sold by the coil or the metre.",
    img: "/img/cable.jpg",
    alt: "Twisted copper electrical wires and cables available at Rama Electricals Goregaon",
    brands: ["Polycab", "KEI", "Finolex", "RR", "Cable Trays", "Hardware Supplier"],
  },
  {
    id: "switches",
    title: "Modular Switches",
    tag: "Plates · Sockets · Dimmers",
    text: "Premium modular switches, sockets, USB chargers, fan regulators and designer plates in glass, metal and matte finishes.",
    img: "/img/switch.jpg",
    alt: "Black modular switch and socket plate on wall",
    brands: ["Legrand", "Anchor", "Schneider"],
  },
  {
    id: "fans",
    title: "Fans & Ventilation",
    tag: "BLDC · Ceiling · Exhaust",
    text: "Energy-saving BLDC ceiling fans, wall fans, pedestal fans and exhaust fans with 5-star ratings to cut your electricity bill.",
    img: "/img/fan.jpg",
    alt: "Ceiling fan casting shadow, BLDC fans in Goregaon East",
    brands: ["Polycab", "Anchor"],
  },
  {
    id: "smart",
    title: "Smart Home Automation",
    tag: "Wi-Fi · Touch · Scenes",
    text: "Touch panels, Wi-Fi smart switches, motion sensors and app-controlled scenes for the modern Mumbai home.",
    img: "/img/smart.jpg",
    alt: "Smart touch switch panel for home automation",
    brands: ["Legrand", "Schneider"],
  },
  {
    id: "protection",
    title: "MCBs, RCCBs & DBs",
    tag: "Safety · Protection",
    text: "Miniature circuit breakers, RCCBs, isolators, changeovers, distribution boards, meters and power supplies that keep every circuit safe and code-compliant.",
    img: "/img/wires.jpg",
    alt: "Electrical cables and circuit protection components",
    brands: ["L&K", "Schneider", "Siemens", "Legrand", "Selec", "Meanwell"],
  },
];

export const BRANDS = [
  { name: "Legrand", primary: true, logo: "/brands/legrand.png", kind: "Switches & automation", invert: true },
  { name: "Polycab", primary: true, logo: "/brands/polycab.png", kind: "Wires & cables" },
  { name: "L&K", primary: true, logo: "/brands/lk.svg", kind: "Switchgear & protection" },
  { name: "Schneider", logo: "/brands/schneider.svg", kind: "Switchgear & automation" },
  { name: "KEI", logo: "/brands/kei.png", kind: "Wires & cables" },
  { name: "Finolex", logo: "/brands/finolex.svg", kind: "Wires & cables" },
  { name: "Siemens", logo: "/brands/siemens.svg", kind: "Switchgear & controls" },
  { name: "Selec", logo: "/brands/selec.png", kind: "Meters & controllers" },
  { name: "Meanwell", logo: "/brands/meanwell.png", kind: "Power supplies & drivers" },
  { name: "Anchor", logo: "/brands/anchor.svg", kind: "Switches & wiring devices" },
  { name: "RR", logo: "/brands/rr.svg", kind: "Wires & cables" },
  { name: "Precision", kind: "Electrical products" },
  { name: "Cable Trays", kind: "Cable management", icon: "tray" },
  { name: "Hardware Supplier", kind: "Fixings & hardware", icon: "hardware" },
];

export const STATS = [
  { value: 5000, suffix: "+", label: "Products in stock" },
  { value: 12, suffix: "+", label: "Trusted brands" },
  { value: 100, suffix: "%", label: "Genuine, GST-billed" },
  { value: 24, suffix: "h", label: "Local delivery window" },
];

export const WHY = [
  { title: "Only genuine stock", text: "Every product is sourced from authorised distributors and billed with GST, so warranties are always honoured." },
  { title: "Retail & wholesale prices", text: "Fair counter prices for homeowners and special rates for electricians, contractors, interior designers and builders." },
  { title: "Advice that saves money", text: "Not sure which cable gauge, MCB rating or fan sweep you need? We help you pick the right part the first time." },
  { title: "Quick local delivery", text: "Fast delivery across Goregaon, Malad, Andheri, Jogeshwari, Borivali and nearby Mumbai suburbs." },
];

export const FAQS = [
  { q: "Where is Rama Electricals located?", a: "We are at A321, MasterMind IV, Royal Palms, Goregaon East, Mumbai 400065. We serve customers across Goregaon, Aarey Colony, Malad, Jogeshwari, Andheri and the western suburbs of Mumbai." },
  { q: "What products does Rama Electricals sell?", a: "We sell wires and cables, modular switches and sockets, ceiling, BLDC and exhaust fans, MCBs, RCCBs, distribution boards, smart home automation products and electrical accessories." },
  { q: "Which electrical brands do you stock?", a: "We are primary dealers for Legrand, Polycab and L&K, and we also stock Schneider, KEI, Finolex, Siemens, Selec, Meanwell, Anchor, RR and Precision, along with cable trays and hardware supplies." },
  { q: "Do you give GST invoices?", a: "Yes. Every purchase comes with a proper GST invoice. Our GSTIN is 27JCKPD9500D1ZO, so businesses can claim input credit." },
  { q: "Do you offer wholesale rates for electricians and contractors?", a: "Yes. Electricians, contractors, interior designers and builders get special trade pricing on bulk and project orders. Send us your material list on WhatsApp for a quick quote." },
  { q: "How can I get a price quote?", a: "Use the form on our Contact page, which opens WhatsApp with your request already written, or call us on +91 93221 26690. We usually reply within a few minutes during store hours." },
  { q: "Do you deliver electrical materials?", a: "Yes, we deliver across Goregaon East, Goregaon West, Malad, Andheri, Jogeshwari, Borivali and nearby areas. Delivery timing depends on order size and location." },
];

export const AREAS = ["Goregaon East", "Goregaon West", "Aarey Colony", "Malad", "Jogeshwari", "Andheri", "Kandivali", "Borivali", "Powai", "Vile Parle"];
